import { Grid, Badge } from '@material-ui/core'
import { useEffect, useState } from 'react'
import { AsterToggleButton, AsterToggleButtonGroup } from 'asterX-UI/Buttons'
import { NotFound } from 'components/NotFound'
import { WorkListTaskCardMobile } from '../WorkListTasks/WorkListTaskCard.mobile'
import { WorkListTaksCardDesktop } from '../WorkListTasks/WorkListTaksCard.desktop'
import { WorkListTaskModal } from '../WorkListTasks/WorkListTaskModal'
import { useHomeStoreRop } from '../../../context/HomeStore/Rop'

export const RopTasksList = () => {
  const {
    homeStore: { tasks, tasksFilter, tasksCount },
    homeStoreFunc: { getTasksList, setTasksFilter }
  } = useHomeStoreRop()

  const isMobile = window.innerWidth < 768

  const [currentTask, setCurrentTask] = useState(null)
  const [taskOpen, setTaskOpen] = useState(false)

  const handleOpenTask = task => {
    setCurrentTask(task)
    setTaskOpen(true)
  }

  const handleCompleted = val => {
    setTasksFilter(prevState => ({ ...prevState, completed: val }))
  }

  useEffect(() => {
    getTasksList(true)
  }, [tasksFilter.completed])

  return (
    <Grid container>
      <Grid item>
        <AsterToggleButtonGroup
          exclusive
          value={tasksFilter.completed}
          onChange={(e, val) => handleCompleted(val)}
        >
          <AsterToggleButton value="open">
            <Badge badgeContent={tasksCount?.open} color="primary" max={9999}>
              Открытые
            </Badge>
          </AsterToggleButton>
          <AsterToggleButton value="closed">
            <Badge badgeContent={tasksCount?.closed} color="primary" max={9999}>
              Закрытые
            </Badge>
          </AsterToggleButton>
        </AsterToggleButtonGroup>
      </Grid>
      <Grid item container spacing={3} style={{ marginTop: 20 }}>
        {tasks?.length ? (
          tasks.map((e, i) => (
            <Grid key={`work-list-view-${i}`} item xs={12}>
              {isMobile ? (
                <WorkListTaskCardMobile
                  task={e}
                  isClosedTasks={tasksFilter.completed === 'closed'}
                  onClick={handleOpenTask}
                />
              ) : (
                <WorkListTaksCardDesktop
                  task={e}
                  isClosedTasks={tasksFilter.completed === 'closed'}
                  onClick={handleOpenTask}
                />
              )}
            </Grid>
          ))
        ) : (
          <NotFound title="Нет задач" />
        )}
      </Grid>
      {taskOpen && (
        <WorkListTaskModal
          task={currentTask}
          isOpen={taskOpen}
          isList
          onClose={() => setTaskOpen(false)}
        />
      )}
    </Grid>
  )
}
